import React, { useEffect, useMemo, useState } from 'react';
import styles from './Topics.module.scss';
import SearchInput from 'component/atom/forms/input/searchInput/SearchInput';
import Button from 'component/atom/forms/button/Button';
import { topics } from 'hooks/endpoints';
import { useFetch } from 'hooks/useFetch';
import NewTopic from './NewTopic';
import { useParams } from 'react-router-dom';
import Loader from 'component/atom/loader/Loader';
import _debounce from 'lodash/debounce';
import TopicItem from './TopicItem';
import { isEmpty } from 'lodash';
import NoData from 'component/molecules/Table/TableComponents/NoData/NoData';

const Topics = () => {
  const [showAddTopic, setShowAddTopic] = useState(false);
  const { id } = useParams();
  const [query, setQuery] = useState({
    botId: id,
  });
  const [search, setSearch] = useState(query?.searchBy || '');

  const { data, refetch, isFetching, isLoading } = useFetch(
    ['topics'],
    topics.getTopics,
    {
      enabled: true,
    },
    query
  );

  const debouncedSearch = useMemo(
    () =>
      _debounce((value) => {
        setQuery({ ...query, searchBy: value });
      }, 300),
    [setQuery, query]
  );

  const handleSearchChange = (name, value) => {
    setSearch(value);
    debouncedSearch(value);
  };

  useEffect(() => {
    refetch();
  }, [query]);

  console.log('data: ', data?.data);

  return (
    <div className={styles['cont']}>
      <div className={styles['search-container']}>
        <SearchInput
          name=''
          value={search}
          onChange={handleSearchChange}
          containerClassName={styles.search}
          classname={styles['search-input']}
          placeholder='Search by topics'
        />
        <Button
          labelClassName={styles.addBtn}
          label='New Topic'
          onClick={() => setShowAddTopic(true)}
          opicBackground
          type='plus'
        />
      </div>
      <div className={styles['topics-container']}>
        {isFetching || isLoading ? (
          <Loader />
        ) : !isEmpty(data?.data?.items) ? (
          data?.data?.items.map((topic) => (
            <TopicItem topic={topic} key={topic?.topicId} refetch={refetch} />
          ))
        ) : (
          <div className={styles['no-data']}>
            <NoData />
          </div>
        )}
      </div>
      <NewTopic
        isOpen={showAddTopic}
        onClose={() => setShowAddTopic(false)}
        refetch={refetch}
        topic={null}
      />
    </div>
  );
};

export default Topics;
